import { IsInt, IsObject, IsOptional, IsUUID, Min, ValidateNested } from 'class-validator';

import { ChatMessageCursor } from './chat-message-cursor';

export class ChatMessageGetListRequest {
    @IsUUID()
    public readonly chatUuid: string;

    @IsInt()
    @Min(1)
    public readonly limit: number;

    @IsOptional()
    @IsObject()
    @ValidateNested()
    public readonly cursor?: ChatMessageCursor;

    constructor(data?: Partial<ChatMessageGetListRequest>) {
        this.chatUuid = data?.chatUuid;
        this.limit = data?.limit === undefined ? 50 : data.limit;
        this.cursor = data?.cursor === undefined || data.cursor === null ? undefined : new ChatMessageCursor(data.cursor);
    }
}
